export default __webpack_public_path__ + "static/media/hasan.29869050.jpg";